<!--
Support incident confirmation screen
@author cm359n
-->
<template>
  <div id="contain" class="container">
  <Nav name="Help" :back="false" :home="true"/>
  <div class="contain">
    <main class="p-2">
      <p id="supportSubmitHdr">Thanks!</p>
      <p id="supportSubmitMsg">
        The issue you have raised has been received and we'll look into it.<br/><br/>

        Confirmation of your incident number has been sent to your UofG email address.<br/><br/>
      </p>
      <img src="@/assets/voteEnd.svg" id="suppEndImg"/>
    </main>
    </div>
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()

//Data
const incidentNumber = ref(0)

onMounted(
  () => {
    incidentNumber.value = route.params.incidentNumber
  }
)
</script>

<style>
#supportBack {
  border: 1px solid #951272;
  background-color:#951272;
  color:#ffffff;
  font-weight:700;
  border-radius:50px;
  text-align:center;
}
.incidentNumber {
  font-weight: bold;
}

#supportSubmitHdr {
  margin-top:45px;
  font-weight: bold;
  font-size: 25px;
  text-align:center;
  color: var(--uog-dark-blue);
}

#supportSubmitMsg {
  text-align:center;
  color: var(--uog-dark-blue);
}

#suppEndImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top:30px;
  margin-bottom:90px;
}
</style>
